import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

function KurbanReportDetailUpdateDialogue({ show, handleClose, updateStatus, data }) {
  const textDeterminer = (data) => {
    switch (data.status) {
      case "WAITING_PARTNER":
        return {
          body: "Apakah Anda Yakin Akan Memproses Proses Data Dengan Nomor Kurban #" + data.kurban_hid,
          header: "Proses Data"
        }
      case "ACCEPTED_PARTNER":
        return {
          body: "Apakah Anda Yakin Akan Memotong Hewan Kurban Data Dengan Nomor Kurban #" + data.kurban_hid,
          header: "Potong Kurban"
        }
      default:
        return {

        }
    }
  }
  return (
    <div>
      {data && <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{textDeterminer(data).header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <i
              className="fas fa-exclamation-circle"
              style={{ fontSize: "64px", color: "#F23013" }}
            ></i>
          </div>
          <br />
          {textDeterminer(data).body}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Batal
          </Button>
          <Button variant="primary" onClick={() => updateStatus(data)}>
            {textDeterminer(data).header}
          </Button>
        </Modal.Footer>
      </Modal>}
    </div>
  )
}

export default KurbanReportDetailUpdateDialogue